import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css!';

class SliderActualites {

  constructor(){
    this.component = document.querySelector('[data-component="slider-actualites"]');
    this.trigger = document.querySelector('[data-trigger="slider-actualites"]');
    this._init();
  }

  _init(){

    if( this.component ){
      let swiper = null;
        
      const firstImage = this.trigger.querySelector('img');
      if(firstImage){
        firstImage.onload = ()=> {
          if(swiper){
            swiper.update();
          }
        };
      }

      swiper = new Swiper(this.trigger, {
        pagination: {
          el: this.component.querySelector('[data-trigger="slider-actualites-pagination"]'),
          type: 'bullets',
          clickable: true
        },
        navigation: {
          nextEl: this.component.querySelector('[data-trigger="slider-actualites-next"]'),
          prevEl: this.component.querySelector('[data-trigger="slider-actualites-prev"]'),
        },
        preloadImages: false,
        lazy: {
          loadOnTransitionStart: true,
        },
        slidesPerView: 2,
        spaceBetween: 20,
        breakpoints: {
          900: {
            slidesPerView: 1,
          }
        }
      });
    }
  }
}

export const sliderActualites = new SliderActualites();